import React, { Component } from "react";
import { Link } from "react-router-dom";
import AdminLoginComponent from "../components/AdminLoginComponent";

import img from "../res/logga.png";
import lundarundan_img from "../res/logga_lundarundan.png";

const isLunda = window.location.host.includes("lundarundan") ? true : false;

class Login extends Component {
  constructor(props) {
    super(props);
  }

  handleToken = (token) => this.props.handleToken(token);

  render() {
    return (
      <div id="login" className="noheader">
        {isLunda ? (
          <img src={lundarundan_img} alt="Lundarundan" />
        ) : (
          <img src={img} alt="Bränteverest" />
        )}

        <AdminLoginComponent {...this.props} handleToken={this.handleToken} />
      </div>
    );
  }
}

export default Login;
